export default {
  computed: {
    isPage() {
      return this.$route.name === 'page';
    },

    pageNotFound() {
      return this.$store.getters.getCurrentPageMode === 'notfound' && this.isPage;
    },
  },
};
